import {apiCall} from "@ui/api/common";
import {FeatureCollection, MultiPoint} from "geojson";

export const updatePosition = (clientId: string, position: GeolocationPosition) => apiCall()
  .post<FeatureCollection<MultiPoint>>(
`/location/update/${clientId}`,
{
      coords: {
        accuracy: position.coords.accuracy,
        altitude: position.coords.altitude,
        altitudeAccuracy: position.coords.altitudeAccuracy,
        heading: position.coords.heading,
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        speed: position.coords.speed,
      },
      timestamp: position.timestamp,
    } // @todo не работает сериализация на старых браузерах
  )
